export const classes = {
  dialog: 'relative size-[1600px] max-w-[90vw] max-h-[90vh] flex flex-col p-0',
  title: 'pb-2 px-4',
  body: 'px-0 py-0 min-h-0 grow',
  video: 'size-full',
  footerWrapper: 'absolute bottom-0 left-0 w-full place-center',
  footer:
    ' mb-4 rounded-xl px-4 py-4 bg-white dark:bg-[#332e43] shadow-dialog place-between',
  deviceField: 'mr-12 max-w-1/2 w-[20rem]',
  nameField: 'mr-20 max-w-1/2 w-[20rem]',
  buttonIcon: 'mr-2',
  buttonsWrapper: 'flex items-center gap-4',
  loading:
    'absolute place-center top-0 left-0 size-full text-grey-8 dark:text-mauve-1 text-base px-12 text-lg',
  hidden: 'hidden',
  photoWrapper: 'flex justify-center size-full',
};

export function buildConstraints(deviceId?: string): MediaStreamConstraints {
  return {
    video: deviceId ? { deviceId } : true,
    audio: false,
  };
}

export function blobToFile(blob: Blob, filename: string) {
  return new File([blob], `${filename}.png`, {
    type: 'image/png',
  });
}

export function renamePhoto(file: File, name: string) {
  // Since file.name is immutable, create a new file to change it
  return file.name === `${name}.png` ? file : blobToFile(file, name);
}
